import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import "./solutions.scss";
import { useParams } from "react-router-dom";
import One from "./One.js";
import Two from "./Two.js";
import Four from "./Four.js";
import Three from "./Three.js";
const pages = ["One", "Two", "Three", "Four"];
//const data = require('./listValues.json')

const All_pages = (page_id) => {
  switch (page_id) {
    case 0:
      return <One />;
    case 1:
      return <Two />;
    case 2:
      return <Three />;
    case 3:
      return <Four />;
  }
};

const scrollToTop = () => {
  window.scrollTo(0, 0);
};

const Solution = () => {
  let { id } = useParams();
  const data = require("../../data/listValues.json");
  return (
    <Container>
      <div className="box" id="about">
        <Row>
          <Col xs={12} md={9}>
            <h6>
              Project Sigma is a website that presents solutions, interactively,
              for{" "}
              <a
                href="https://projecteuler.net/archives"
                target="_blank"
                className="reflink"
              >
                Project Euler Problems.
              </a>
            </h6>
            <h3 align="center">SOLUTION TO PROBLEM {id}</h3>
            {id < 5 ? (
              <div className="About">
                <h4>{data.items[id - 1].title}</h4>
                <h5>Problem Statement</h5>
                <p>{data.items[id - 1].problemDescription}</p>
                <h5>Solution Approach</h5>
                {All_pages(id - 1)}
                {/*<Two dataLoad={data.items[id-1]} idLoad={id-1} />*/}
              </div>
            ) : (
              <div>
                <h4>{data.items[id - 1].title}</h4>
                <h5>Problem Statement</h5>
                <p>{data.items[id - 1].problemDescription}</p>
                <h5>Solution Approach</h5>
                <p>Solution to problem {id} is in progress.</p>
                <p>Coming soon!</p>
              </div>
            )}
            <div align="center">
              {id > 1 ? (
                <span>
                  <Link to={`/solutions/problem/${id - 1}`}>
                    {" "}
                    <button
                      onClick={scrollToTop}
                      class="btn btn-secondary my-2 my-sm-0 solnav"
                    >
                      Prev
                    </button>
                  </Link>
                  <Link to={`/solutions/problem/${+id + +1}`}>
                    {" "}
                    <button
                      onClick={scrollToTop}
                      class="btn btn-secondary my-2 my-sm-0 solnav"
                    >
                      Next
                    </button>
                  </Link>
                </span>
              ) : (
                <span>
                  <Link to={`/solutions/problem/${+id + +1}`}>
                    {" "}
                    <button
                      onClick={scrollToTop}
                      class="btn btn-secondary my-2 my-sm-0 solnav"
                    >
                      Next
                    </button>
                  </Link>
                </span>
              )}
            </div>
          </Col>
          <Col xs={0} md={3}>
            {/*<h5>Related Problems</h5>*/}
          </Col>
        </Row>
      </div>
    </Container>
  );
};
export default Solution;
